/**
 * Multi-relation driver factory.
 *
 * Delegates to engine implementations based on `def.engine` (default: 'chips').
 * To add a new engine, create a file in `engines/` and register it in the map below.
 */
import * as chipsEngine from './engines/chips-engine.js';
import * as searchableMultiEngine from './engines/searchable-multi-engine.js';

/** @type {Record<string, { mount: (container: HTMLElement, ctx: import('../../../contracts/forms.js').FieldDriverContext) => import('../../../contracts/forms.js').FieldDriverHandle }>} */
const engines = {
  chips: chipsEngine,
  'searchable-multi': searchableMultiEngine,
};

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const multiRelationDriver = {
  type: 'multi-relation',
  mount(container, ctx) {
    const mrDef = /** @type {import('../../../contracts/forms.js').MultiRelationFieldDef} */ (ctx.def);
    const engineName = mrDef.engine ?? 'chips';
    const engine = engines[engineName];
    if (!engine) {
      throw new Error(`Unknown multi-relation engine: '${engineName}'`);
    }
    return engine.mount(container, ctx);
  },
};
